/** Determine if code run on server side */
export const isOnServer = (): boolean => typeof window === 'undefined';
